import React from 'react'
export default () => {
    return (
        <div className="header_background_spacer"></div>
    );
};


// WEBPACK FOOTER //
// ./src/js/components/HeaderBG.js